var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotationMark7228448(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 52.916666 52.916666",
    id: "svg5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g115144"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.812805,2.7913975e-6 C 22.812805,2.7913975e-6 3.8122982,7.9159225 0.93929935,18.435439 -2.1306856,29.676216 2.6594118,36.595546 10.443372,37.933574 16.443489,38.964967 22.301801,35.96501 23.416821,29.478388 24.531842,22.991764 18.263152,17.193431 11.488661,18.593421 v 0 C 10.762956,11.25671 24.788155,3.956486 24.788155,3.956486 Z",
    style: {
      fontSize: "132.292px",
      fontFamily: "'Liberation Serif'",
      InkscapeFontSpecification: "'Noto Sans CJK HK'",
      opacity: 1,
      fill: "#174894",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.329087,
      strokeOpacity: 1
    },
    id: "path31770-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.941317,1.9011945e-7 c 0,0 -19.000506,7.91592230988055 -21.873505,18.43543880988055 -3.069985,11.240777 1.720112,18.160107 9.504073,19.498135 6.000116,1.031393 11.858429,-1.968564 12.973449,-8.455186 1.115021,-6.486624 -5.153669,-12.284957 -11.92816,-10.884967 v 0 C 38.891469,11.25671 52.916667,3.956486 52.916667,3.956486 Z",
    style: {
      fontSize: "132.292px",
      fontFamily: "'Liberation Serif'",
      InkscapeFontSpecification: "'Noto Sans CJK HK'",
      opacity: 1,
      fill: "#174894",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.329087,
      strokeOpacity: 1
    },
    id: "path31770-0-8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotationMark7228448);
export default __webpack_public_path__ + "static/media/quotation-mark-7228448.6e28f759258b67c25ba995154a8cdd54.svg";
export { ForwardRef as ReactComponent };